import * as React from 'react';
import {
  dismissInstallBanner,
  getPwaState,
  subscribePwa,
  triggerInstall,
} from '../../core/pwa';

const bannerStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: 16,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 9999,
  maxWidth: 420,
  width: 'calc(100% - 32px)',
  background: '#1f2937',
  color: '#fff',
  borderRadius: 10,
  padding: '14px 16px',
  boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
  fontSize: 14,
  lineHeight: 1.5,
};

const closeStyle: React.CSSProperties = {
  position: 'absolute',
  top: 8,
  right: 10,
  background: 'transparent',
  border: 'none',
  color: '#fff',
  cursor: 'pointer',
  fontSize: 18,
  lineHeight: 1,
  padding: 4,
};

const actionStyle: React.CSSProperties = {
  marginTop: 10,
  background: '#fff',
  color: '#1f2937',
  border: 'none',
  borderRadius: 6,
  padding: '8px 14px',
  fontWeight: 600,
  cursor: 'pointer',
  fontSize: 13,
};

function renderHint(installHint: string, onInstall: () => void) {
  switch (installHint) {
    case 'safari-ios':
      return (
        <p style={{ margin: 0 }}>
          Install this admin panel on your device: tap <strong>Share</strong>, then{' '}
          <strong>Add to Home Screen</strong>.
        </p>
      );
    case 'firefox-android':
      return (
        <p style={{ margin: 0 }}>
          Install this admin panel: open the browser menu and tap <strong>Install</strong>.
        </p>
      );
    case 'chrome':
    case 'edge':
      return (
        <>
          <p style={{ margin: 0 }}>
            Install this admin panel for a fullscreen, browser-free experience on tablets and phones.
          </p>
          <button type="button" style={actionStyle} onClick={onInstall}>
            Add to Home Screen
          </button>
        </>
      );
    default:
      return (
        <p style={{ margin: 0 }}>
          Add this page to your home screen from your browser menu for a standalone app experience.
        </p>
      );
  }
}

export class PwaInstallBanner extends React.Component {
  private unsubscribe?: () => void;

  state = {
    enabled: getPwaState().enabled === true,
    showBanner: getPwaState().showBanner,
    installHint: getPwaState().installHint,
  };

  componentDidMount() {
    this.unsubscribe = subscribePwa(() => {
      const next = getPwaState();
      this.setState({
        enabled: next.enabled === true,
        showBanner: next.showBanner,
        installHint: next.installHint,
      });
    });
  }

  componentWillUnmount() {
    this.unsubscribe?.();
  }

  handleDismiss = () => {
    dismissInstallBanner();
  };

  handleInstall = () => {
    triggerInstall().catch(() => undefined);
  };

  render() {
    if (this.state.enabled !== true || !this.state.showBanner) {
      return null;
    }

    return (
      <div style={bannerStyle} role="status" aria-live="polite">
        <button type="button" style={closeStyle} onClick={this.handleDismiss} aria-label="Dismiss">
          ×
        </button>
        {renderHint(this.state.installHint, this.handleInstall)}
      </div>
    );
  }
}

export default PwaInstallBanner;
